import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Instagram, X } from "lucide-react";
import { Reveal, SectionTitle } from "./Reveal";
import { GALLERY, INSTAGRAM_URL, INSTAGRAM_HANDLE } from "@/data/site";

export const Gallery = () => {
  const [active, setActive] = useState(null);
  return (
    <section id="galeri" className="relative py-28 lg:py-36 bg-white" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <SectionTitle eyebrow="Galeri" title={<>Instagram'dan <span className="text-gradient">ilham</span> kareler</>} desc="Tırnak tasarımları, ipek kirpik, cilt bakımı ve salonumuzdan görüntüler." />
          <Reveal delay={0.2}>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="gallery-instagram-button" className="btn-outline inline-flex items-center gap-2 font-semibold px-7 py-4 rounded-full text-[#1a1118]">
              <Instagram size={18} className="text-[#e6007e]" /> {INSTAGRAM_HANDLE}
            </a>
          </Reveal>
        </div>
        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 auto-rows-[160px] sm:auto-rows-[200px] lg:auto-rows-[240px] gap-3 sm:gap-4">
          {GALLERY.map((g, i) => (
            <motion.button
              key={g.src}
              type="button"
              data-testid={`gallery-item-${i}`}
              onClick={() => setActive(g)}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: (i % 4) * 0.08 }}
              className={`group relative rounded-2xl sm:rounded-3xl overflow-hidden ${g.span} focus:outline-none focus-visible:ring-2 focus-visible:ring-[#e6007e]`}
            >
              <img src={g.src} alt={g.alt} loading="lazy" className="w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#8b004f]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <Instagram size={22} className="absolute bottom-4 right-4 text-white opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500" />
            </motion.button>
          ))}
        </div>
      </div>
      <AnimatePresence>
        {active && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setActive(null)} className="fixed inset-0 z-[80] bg-[#0a0a0a]/90 backdrop-blur-md flex items-center justify-center p-4" data-testid="gallery-lightbox">
            <button onClick={() => setActive(null)} data-testid="gallery-lightbox-close" aria-label="Kapat" className="absolute top-5 right-5 w-12 h-12 rounded-full bg-white/10 border border-white/20 text-white flex items-center justify-center hover:bg-white hover:text-[#e6007e] transition-colors"><X size={20} /></button>
            <motion.img initial={{ scale: 0.9, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.95 }} transition={{ duration: 0.4 }} src={active.src} alt={active.alt} className="max-h-[85vh] max-w-full rounded-3xl shadow-2xl object-contain" onClick={(e) => e.stopPropagation()} />
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};
